import { fetchWithHeaders, parseResponse } from '../shared/utils'

export function fetchAll() {
  return fetchWithHeaders('/v1/pages', {
    method: 'GET',
  }).then(parseResponse)
}
